<template>
  <div class='login-new-box' data-part="newLogin">
    <div class='header'>
      <router-link to="" class="head-right">
        <!-- <mt-button icon="back" @click="goback()"></mt-button> -->
      </router-link>
      <div class="btn-box">
        <button :class="{active:tab=='1'}" @click="tabSwitch('1')">手机</button>
        <button :class="{active:tab=='2'}" @click="tabSwitch('2')">邮箱</button>
      </div>
      <span class="head-right"></span>
    </div>
    <div class="content-box">
      <div v-show="tab==1" class="phone-line" :class="{bottomLine:areaCode!=86}">
      <!-- <div v-show="tab==1"> -->
        <span class="country code-box" @click="pop2=true" :class="{bottomLine:areaCode==86}">
          <em>+{{areaCode}}</em>
          <i class="iconfont icon-xiala-copy"></i>
        </span>
        <div class="phone-in">
          <div class="separate-box" @click="inputClick('phoneDom')" v-show="areaCode==86">
            <i v-for="i in 11" :key="i" :class="{bottomLine:areaCode==86}">{{pwdArray[i-1]}}</i>
          </div>
          <input
            v-model="userParam.mobileInput"
            :class="{outStyle:phoneInput}"
            @focus="inputFocus('phoneInput')"
            @input="separateNum('mobileInput','phoneDom')"
            ref="phoneDom"
            type="number"
            placeholder="请输入手机号">
        </div>
        <!-- <separateBox :lineHide="lineHide" :clear="numClear" @phoneOver="phoneFinish" numType="phone" :codeType="tab"></separateBox> -->
      </div>
      <div class="email-line bottomLine" v-show="tab==2">
        <input v-model="userParam.email" @input="emailModify" type="text" placeholder="请输入邮箱" >
      </div>
      <div class="validate-line" v-show="boxShow=='code'">
        <div class="separate-box" @click="inputClick('codeDom')">
          <i v-for="i in codeNum" :key="i" :class="{little:codeNum==6}" class="bottomLine">{{codeArray[i-1]}}</i>
        </div>
        <input
          type="text"
          v-model="userParam.code"
          :class="{outStyle:codeInput}"
          @focus="inputFocus('codeInput')"
          @input="separateNum('code','codeDom')"
          ref="codeDom"
          placeholder="请输入验证码">
        <div class="right-btn" v-show="voiceState">
          <span class="get-code" v-show="codestate==0" @click="setCode1()">获取验证码</span>
          <span v-show="codestate==1">已发送{{secondNum}}s</span>
        </div>
      </div>
      <!-- <separateBox :clear="numClear" v-show="boxShow=='code'" numType="code" :codeType="tab"></separateBox> -->
      <div class="pwd-line" v-show="boxShow=='pwd'">
        <input v-show="!pwdshow" type="password" placeholder="请输入密码" v-model="userParam.pwdNum">
        <input v-show="pwdshow" type="text" placeholder="请输入密码" v-model="userParam.pwdNum">
        <i class='iconfont icon-yanjing' :class="{noSee:!pwdshow,see:pwdshow}" @click="pwdshow=!pwdshow"></i>
      </div>
      <div class="voice-box" v-show="voiceShow&&tab==1&&boxShow=='code'">
        <span v-show="voiceState" @click="voiceVerification(this)">收不到短信？试试<em>语音验证</em></span>
        <span v-show="!voiceState">请注意接听语音验证电话（{{secondNum}}s）</span>
      </div>
      <div class="forget-line" v-show="userType=='login'">
        <span @click="goForgetPwd()">忘记密码</span>
      </div>
      <div class="submit-line" v-show="nextStep" @click="showCodeBox">
        下一步
      </div>
      <div class="submit-line" v-show="submitShow" @click="goSubmit">
        登录/注册
      </div>
      <div class="switch-line" v-show="userType=='login'">
        <span v-show="boxShow=='code'" @click="loginSwitch">密码登录</span>
        <span v-show="boxShow=='pwd'" @click="loginSwitch">验证码登录</span>
      </div>
    </div>

    <mt-popup
      v-model="popupVisible2"
      popup-transition="popup-fade"
      :modal="false"
      class="spinner-box">
      <mt-spinner class="pop-spinner" type="fading-circle"></mt-spinner>
    </mt-popup>
    <mt-popup
      v-model="popupVisible3"
      popup-transition="popup-fade"
      :modal="false"
      class="spinner-box">
      <mt-spinner class="pop-spinner" type="fading-circle"></mt-spinner>
      <!-- <div class="spin-word">加载中</div> -->
    </mt-popup>

    <mt-popup v-model="pop2" position="bottom" class="addresspop pickerPop">
      <div class='button-line'>
        <button @click="pop2=false">取消</button>
        <span>选择所属国家或地区</span>
        <button @click="selectSure">确定</button>
      </div>
      <mt-picker :slots="countryslot" @change="selectCountry" value-key="ch_name"></mt-picker>
    </mt-popup>

    <mt-popup v-model="dialog1" class="tip-pop" popup-transition="popup-fade">
      <div class='content'>
        <h2>提示</h2>
        <p>
          您还没有设置过登录密码，无法使用密码登录。
        </p>
      </div>
      <div class='btn-box'>
        <span @click="goSetPwd">设置密码</span>
        <span @click="dialog1=false">验证码登录</span>
      </div>
    </mt-popup>

    <mt-popup
      :closeOnClickModal="false"
      v-model="patternVerification"
      class="tip-pop"
      popup-transition="popup-fade">
      <div id="TCaptcha"></div>
    </mt-popup>
  </div>
</template>

<script>
  import {ajax,setMessage,getMessage} from '../../assets/js/common'
  import {
    inputFocus,
    separateNum,
    countryCheck,
    quickReg,
    quickLogin,
    setCode,
    setEmail,
    speechVerification
  } from "../../assets/js/login-common"
  import separateBox from "./separate-num.vue"
  export default{
    name:"login-reg",
    data(){
      return{
        tab:1,
        numClear:false,
        userParam:{
          "pwdNum":"",
          "mobileInput":"",
          "code":"",
          "email":"",
        },
        userType:"",//标识注册还是登录
        boxShow:"",
        pwdSet:false,//true表示已设置密码，false未设置
        pwdshow:false,
        voiceShow:false,
        voiceState:true,
        secondNum:60,
        codestate:0,
        pop2:false,
        dialog1:false,
        popupVisible2:false,
        popupVisible3:false,
        patternVerification:false,
        areaCode:86,
        phoneInput:false,
        codeInput:false,
        // pwdArray:[],
        // codeArray:[],
        nextStep:true,//控制下一步按钮的显示
        submitShow:false,//控制登录、注册按钮的显示
        loginRegBtn:true,
        countryslot:[
          {
            flex: 1,
            values: [],
            className: 'slot1',
            textAlign: 'center'
          },
        ],
        backType:false,//true表示由设置密码等页面跳回，需保留信息
        lineHide:false,//true需隐藏分隔数字
        patternParam:{
          ticket:"",
          businessId:""
        },
      }
    },
    computed:{
      pwdArray(){
        let array=this.userParam['mobileInput'].toString().split('');
        return array;
      },
      codeArray(){
        let array=this.userParam['code'].toString().split('');
        return array;
      },
      codeNum(){
        let val;
        if(this.tab==1){
          val=4;
        }
        else{
          // val=6;
          val=4;
        }
        return val;
      }
    },
    components:{
      separateBox
    },
    watch:{
      areaCode(val){
        this.inputFocus('phoneInput');
        if(!this.backType){
          this.goOrigin();
        }
        else{
          this.backType=false;
        }

      },
      tab(val){
        if(!this.backType){
          this.goOrigin();
        }
        else{
          this.backType=false;
        }
        // if(val==2){
        //   this.boxShow='pwd';
        // }
      },
      "userParam.mobileInput":function(val){

      }
    },
    mounted(){
      this.$nextTick(()=>{
        this.countryCheck();
        // this.showCodeBox();
        let setParam=sessionStorage.getItem('setParam');
        if(setParam){
          setParam=JSON.parse(setParam);
          this.backType=true;
          this.tab=setParam.type;
          if(this.tab==1){
            this.areaCode=setParam.areaCode;
            this.userParam.mobileInput=setParam.mobile;
          }
          else{
            this.userParam.email=setParam.email;
          }
          this.showCodeBox();
          this.inputFocus('phoneInput');
          this.separateNum("mobileInput","phoneDom");
        }
      })
    },
    methods:{
      /*登录或注册*/
      goSubmit(){
        let arr=["sms","email"];
        let loginType={
          code:"code",
          pwd:"password",
        };
        let param={
          type:arr[this.tab-1],
          area:this.areaCode,
          mobile:this.userParam.mobileInput,
          code:this.userParam.code,
          redirect_uri:"https://zhaobi.com",
          email:this.userParam.email
        };
        let paramLogin={};
        for(let x in param){
          paramLogin[x]=param[x];
        }
        paramLogin.logintype=loginType[this.boxShow];
        paramLogin.broker_code="";
        paramLogin.password=this.userParam.pwdNum;


        if(this.userType=='reg'){
          if(this.$route.query.code){
            param.invite_code=this.$route.query.code;
          }
          quickReg(this,param,paramLogin);
        }
        else{
          quickLogin(this,paramLogin);
        }
      },
      /*输完手机号*/
      phoneFinish(val,type){
        this.showCodeBox();
        if(type=='phone'){
          this.userParam.mobileInput=val;
        }
        else{
          this.userParam.code=val;
        }

        // console.log(val,type);
      },
      /*跳转至找回密码页面*/
      goForgetPwd(){
        this.saveMsg();
        this.$router.push({path:"/retrievePwd"});
      },
      /*存储当前页填写信息*/
      saveMsg(){
        let param={
          type:this.tab,
          email:this.userParam.email,
          areaCode:this.areaCode,
          mobile:this.userParam.mobileInput,
        };
        param=JSON.stringify(param);
        sessionStorage.setItem("setParam",param);
      },
      /*跳转至设置密码页面*/
      goSetPwd(){
        this.saveMsg();
        this.$router.push({path:"/setPwd"});
      },
      /*登录方式切换*/
      loginSwitch(type){
        if(this.boxShow=='code'){
          if(this.pwdSet==1){
            this.boxShow='pwd';
          }
          else{
            this.dialog1=true;
          }

        }
        else if(this.boxShow=='pwd'){
          this.boxShow='code';
        }
      },
      /*注册*/
      register(val){
        console.log('register');
        return;
        if(this.rePwd==""){
          this.Toast("请先输入密码");
          return false;
        }
        let param={};
        if(this.tab==1){
          param={
            mobile:this.reUser,
            password:this.rePwd,
            code:this.reCode,
            checkmethod:"data",
            type:"sms",
            area:this.areaCode,
            invite_code:this.invite_code
          };
        }
        else if(this.tab==2){
          let name=$("#login-name").val();
          param={
            email:name,
            password:this.rePwd,
            code:this.reCode,
            checkmethod:"data",
            type:"email",
            invite_code:this.invite_code
          };
        }
        var that=this;
        this.redelay=0;
        // this.popupVisible2=true;
        ajax(this,this.extendApi.userReg,param,(data)=>{
          // this.popupVisible2=false;
          this.redelay=1;
          if(data.code==200){
            this.popupVisible2=false;
            if(this.tab==1){
              this.login(this.reUser,this.rePwd,this.areaCode);
            }
            if(this.tab==2){
              this.login(name,this.rePwd);
            }
          }
          else{
            Toast(data.message);
          }
        },"post");

      },
      // addJs(src){
      //   let dom1=document.createElement("script");
      //   dom1.src=src;
      //   document.getElementsByTagName("body")[0].appendChild(dom1);
      //   dom1.onload=()=>{
      //     var capOption = {callback:this.cbfn, showHeader:true,type:"popup"};
      //     capInit(document.getElementById("TCaptcha"), capOption);
      //   }
      // },
      //回调函数：验证码页面关闭时回调
      cbfn(retJson) {
        console.log(retJson);
        this.patternVerification=false;
        capDestroy();
        if (retJson.ret == 0) {
        // 用户验证成功
          this.patternParam.ticket=retJson.ticket;
          // this.Toast("验证成功");
          this.setCode1();
        }
        else {
            //用户关闭验证码页面，没有验证
        }
      },
      // /* 图形验证码 */
      // patternCode(src){
      //   this.patternVerification=true;
      //   this.addJs(src);
      //   // var capOption = {callback:this.cbfn, showHeader:true,type:"popup"};
      //   // capInit(document.getElementById("TCaptcha"), capOption);

      // },
      /*发送验证码*/
      setCode1(){
        var codetype="quick";
        var vparam;
        vparam="FzmRandom";
        if(this.tab==1){
          if(!this.voiceState){
            return false;
          }
          if(this.userParam.mobileInput==""){
            this.Toast("请先输入手机号");
            return false;
          }
          this.voiceShow=false;
          this.popupVisible2=true;

          /*test*/
          // this.codestate=1;
          // return;

          setCode(this,codetype,vparam,this.userParam.mobileInput,(data)=>{
            this.popupVisible2=false;
            if(data.code==200){
              // if(data.data.isShow==1){
              //   this.patternCode(data.data.data.jsUrl);
              //   this.patternParam.businessId=data.data.data.businessId;
              // }
            }
          },this.patternParam.ticket,this.patternParam.businessId);
        }
        else if(this.tab==2){
          // let name=$("#login-name").val();
          let name=this.userParam.email;
          if(name==""){
            this.Toast("请先输入邮箱");
            return false;
          }
          this.popupVisible2=true;
          // vparam="FzmDateTime|FzmRandom";

          /*test*/
          // this.codestate=1;
          // return;

          setEmail(this,codetype,vparam,name,(data)=>{
            this.popupVisible2=false;
            if(data.code==200){
              // if(data.data.isShow==1){
              //   this.patternCode(data.data.data.jsUrl);
              // }
            }
          },this.patternParam.ticket,this.patternParam.businessId);
        }
      },
      /*语音验证*/
      voiceVerification(){
        // if(this.reUser==""){
        //   this.Toast("请先输入手机号");
        //   return false;
        // }
        let param={
          area:this.areaCode,
          mobile:this.userParam.mobileInput,
          codetype:"quick"
        };
        speechVerification(this,param);
      },
      inputClick(val){
        this.$refs[val].focus();
      },
      /*拆分input输入值*/
      separateNum(val,ref){
        separateNum(val,ref,this,'logReg');
        // let array=this.userParam[val].toString().split('');

        // if(val=='mobileInput'){
        //   this.pwdArray=array;
        //   if(this.areaCode==86){
        //     if(array.length>10){
        //       this.$refs[ref].blur();
        //     }
        //     if(array.length==11){
        //       this.showCodeBox();
        //     }
        //   }
        // }
        // else{
        //   this.codeArray=array;
        //   if(array.length>3){
        //     this.$nextTick(()=>{
        //       this.$refs[ref].blur();
        //     })
        //   }
        // }
      },
      /*清除separateBox组件数据*/
      codeClear(){
        this.numClear=true;
        setTimeout(()=>{
          this.numClear=false;
        },300);
      },
      /*邮箱输入方法*/
      emailModify(){
        if(this.boxShow!=""){
          this.goOrigin('modify');
        }
      },
      /*恢复初始状态*/
      goOrigin(type){
        this.userType="";
        this.boxShow="";
        this.nextStep=true;
        this.submitShow=false;
        if(type=='modify'){

        }
        else{
          for(let x in this.userParam){
            this.userParam[x]="";
          }
        }

        // this.codeArray=[];
        // this.pwdArray=[];
        // this.codeClear();
      },
      /*显示验证码输入框*/
      showCodeBox(){
        this.popupVisible2=true;
        let arr={
          "1":"sms",
          "2":"email"
        };
        let param={
          mobile:this.userParam.mobileInput,
          area:this.areaCode,
          type:arr[this.tab],
          email:this.userParam.email,
        };
        ajax(this,this.extendApi.isReg,param,(data)=>{
          this.popupVisible2=false;
          if(data.code==200){
            this.nextStep=false;
            this.submitShow=true;

            // 0:未注册
            if(data.data.uid=='0'){
              this.userType='reg';
            }
            else{
              this.userType='login';
            }
            if(this.userType=='reg'){
              this.boxShow='code';
            }
            else{
              this.pwdSet=data.data.ispwd;
              // 1:密码已设置
              if(this.pwdSet==1){
                this.boxShow='pwd';
              }
              else{
                this.boxShow='code';
              }
            }
          }
          else{
            this.Toast(data.message);
          }
        },"GET");
      },
      /*手机输入框获取焦点*/
      inputFocus(val){
        inputFocus(val,this);
      },
      /*手机国家获取*/
      countryCheck(){
        countryCheck(this);
      },
      selectSure(){
        this.pop2=false;
        this.areaCode=this.countryVal.code;
      },
      /*手机国家选择*/
      selectCountry(picker, values){
        this.countryVal=values[0];
      },
      tabSwitch(val){
        this.tab=val;
      }
    }
  }
</script>

<style>
  .login-new-box{

  }
</style>



// WEBPACK FOOTER //
// src/views/login/loginNew.vue